import { createGlobalStyle } from 'styled-components';
import theme from '../../theme';

const GlobalStyle = createGlobalStyle`
  :root{
    --primary: ${theme['@primary-color']};
    --orange: #F4A01D;
    --blue: #0B8AF7;
    --error: #B00020;
    --success: #388E3C;
    --system-bg: #F6F7F9;
    --text-grey-8: #262626;
    --text-grey-7: #464748;
    --text-grey-6: #656668;
    --text-grey-5: #A3A4A5;
    --text-grey-4: #C1C2C3;
    --text-grey-3: #E4E5E7;
    --text-grey-2: #F0F1F3;
    --text-grey-1: #F6F7F9;
  }

  #root{
    display: flex;
    height: 100%;
  }

  #container{
    background: #f6f7f9;
    height: 100%;
    overflow-y: auto;
    max-height: 100vh;
    flex: 1;
  }

  #root .ant-select-focused .ant-select-selection,
  #root .ant-select-selection:focus,
  #root .ant-select-selection:active {
    border-color: #fa075a;
    -webkit-box-shadow: 0 0 0 2px rgba(250, 7, 90, 0.2);
    box-shadow: 0 0 0 2px rgba(250, 7, 90, 0.2);
  }

  #root .ant-input:hover, #root .ant-input:focus {
    border-color: #fa075a;
    border-right-width: 1px !important;
    box-shadow: rgb(190 0 0 / 20%) 0px 0px 0px 2px;
  }

  /* allowClear (e outros sufixos) usam .ant-input-affix-wrapper na borda; o tema define @input-border-color e o seletor .ant-input acima não cobre o wrapper */
  .ant-input-affix-wrapper, .ant-input, .ant-input[disabled] {
    border-color: #d9d9d9;
  }

  #root .ant-input-affix-wrapper:hover,
  #root .ant-input-affix-wrapper:focus,
  #root .ant-input-affix-wrapper-focused:not(.ant-input-affix-wrapper-disabled) {
    border-color: #fa075a;
    box-shadow: rgb(190 0 0 / 20%) 0px 0px 0px 2px;
  }

  #root .ant-input-number:focus,
  #root .ant-input-number:hover,
  #root .ant-input-number:active,
  #root .ant-input-number:active {
    border-color: #fa075a;
    border-right-width: 1px !important;
  }

  a.ant-btn {
    &.ant-btn-link:hover {
      span {
        text-decoration: underline;
      }
    }
  }

  button.ant-btn {
    &:not(.ant-btn-icon-only) {
      min-width: 112px;
    }

    &.ant-btn-link:hover {
      span {
        text-decoration: underline;
      }
    }
  }

`;

export default GlobalStyle;
